import * as firebase from 'firebase/app';
import 'firebase/firestore';
import {
  ONBOARDING_QUESTIONS,
  ONBOARDING_RESPONSES,
  ONBOARDING_RESPONSES_DETAILS
} from 'utils/constants/collectionNames';

import { BEGIN_AGREEMENT, AGREEMENT } from 'utils/constants/OnboardingQuestions';

import {
  GET_ONBOARDING_QUESTIONS_SUCCEED,
  GET_ONBOARDING_QUESTIONS_ERROR,
  GET_ONBOARDING_RESPONSES_SUCCEED,
  GET_ONBOARDING_RESPONSES_ERROR,
  GET_AGREEMENT_SUCCEED,
  GET_AGREEMENT_ERROR,
  GET_CLIENT_AGREEMENT_SIGNATURE_SUCCEED,
  GET_CLIENT_AGREEMENT_SIGNATURE_ERROR,
  LOADING_QUESTIONS_STATE,
  LOADING_RESPONCES_STATE,
  LOADING_AGREEMENT_STATE,
  LOADING_CLIENT_AGREEMENT_SIGNATURE
} from './types';

export const getOnboardingQuestions = clientId => async dispatch => {
  let firestore = firebase.firestore();
  const docRef = firestore.collection(ONBOARDING_QUESTIONS).orderBy('order', 'asc');
  dispatch({
    type: LOADING_QUESTIONS_STATE
  });
  docRef
    .get()
    .then(querySnapshot => {
      let onboardingQuestions = querySnapshot.docs.map(doc => {
        return { ...doc.data(), id: doc.id };
      });

      dispatch({
        type: GET_ONBOARDING_QUESTIONS_SUCCEED,
        payload: onboardingQuestions
      });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_ONBOARDING_QUESTIONS_ERROR,
        payload: `error: ${err}`
      });
    });
};

export const getOnboardingResponses = clientId => async dispatch => {
  let firestore = firebase.firestore();
  const docRef = firestore
    .collection(`/${ONBOARDING_RESPONSES}/${clientId}/${ONBOARDING_RESPONSES_DETAILS}`);
  dispatch({
    type: LOADING_RESPONCES_STATE
  });
  docRef
    .get()
    .then(querySnapshot => {
      let onboardingResponses = {};
      querySnapshot.docs.forEach(doc => {
        onboardingResponses[`${doc.id}`] = doc.data().value;
      });

      dispatch({
        type: GET_ONBOARDING_RESPONSES_SUCCEED,
        payload: onboardingResponses
      });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_ONBOARDING_RESPONSES_ERROR,
        payload: `error: ${err}`
      });
    });
};

export const getAgreementText = () => async dispatch => {
  let firestore = firebase.firestore();
  const docRef = firestore.collection(ONBOARDING_QUESTIONS).doc(AGREEMENT);
  dispatch({
    type: LOADING_AGREEMENT_STATE
  });
  docRef
    .get()
    .then(doc => {
      dispatch({
        type: GET_AGREEMENT_SUCCEED,
        payload: { ...doc.data() }
      });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_AGREEMENT_ERROR,
        payload: `error: ${err}`
      });
    });
};

export const getClientAgreementSignture = clientId => async dispatch => {
  let firestore = firebase.firestore();
  const docRef = firestore
    .collection(`/${ONBOARDING_RESPONSES}/${clientId}/${ONBOARDING_RESPONSES_DETAILS}`)
    .doc(BEGIN_AGREEMENT);
  dispatch({
    type: LOADING_CLIENT_AGREEMENT_SIGNATURE
  });
  docRef
    .get()
    .then(doc => {
      dispatch({
        type: GET_CLIENT_AGREEMENT_SIGNATURE_SUCCEED,
        payload: doc.data() ? doc.data().value : null
      });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_CLIENT_AGREEMENT_SIGNATURE_ERROR,
        payload: `error: ${err}`
      });
    });
};
